/* assets/mf-gift-pair.js — MYSTERY GIFT, ONE PER ORDER (PL 2026-10-05, owner: "one gift per order, not per case";
 * the A/B/C test is over and everyone gets the gift free).
 *
 * The product page adds the gift (MYSTERY PREZENT, settings.promotional_product, SKU GIFT_SKU) with a case only while
 * the cart holds no gift line yet (sections/product-rhode.liquid). This file keeps the CART in that shape whatever
 * happened since - a drawer change, another tab, an older cart from the one-gift-per-case days:
 *   - at most ONE gift line, of ONE unit (a second line goes, a quantity above 1 drops to 1);
 *   - the gift is PAIRED with a case that is still in the cart: its caseSku line property equals that case's SKU
 *     (or variant id) and its camera-ring mark matches, which is exactly what the pl-one-plus-one discount Function
 *     (free gift) and the drawer (sections/mini-cart.liquid: the gift follows its case's delete) look for. When its
 *     case leaves - a delete, a '-' or a typed 0 - and other cases remain, the gift is RE-PAIRED to one of them
 *     (caseSku + the visible 'Do etui' + the ring mark, one /cart/change.js), never removed;
 *   - with NO case left, the gift goes.
 * It never ADDS a gift: only the product page does. A case's + / - never moves the gift (the drawer's links leave
 * it out), so raising a case's quantity cannot add gifts either.
 *
 * A CASE is a Pro-Shock / Full-Shock / Real-Material line that is neither a screen protector, the gift nor a bundle
 * add-on (_bundleEpoch) - the drawer's own type rule (mini-cart: currentLineItemType / _mg_case_lines). The gift is
 * never in all-cases, so it never counts as one.
 *
 * Runs after every cart:updated / cart:refresh (debounced) and once at load for a cart that holds items. It decides
 * on the cart the event carried (or mfCart), and before any WRITE re-reads a fresh /cart.js and decides again, so a
 * stale event can never remove or move the wrong line. A check that lands while a repair is in flight runs once more
 * after it, on a fresh /cart.js. Its own repaint events are ignored, and corrective writes are capped (4 per 30 s) so
 * a cart that refuses a change can never loop.
 */
(function () {
  'use strict';
  var D = document, W = window;
  var GIFT_SKU = 'bd190100-a41f-4db0-a466-f300b90c8d75';
  var RING = 'Pierścień aparatu';
  var PAIR_LABEL = 'Do etui';
  var me = D.currentScript;
  var GIFT_VID = me ? (parseInt(me.getAttribute('data-gift-variant'), 10) || 0) : 0;

  function isGift(li) { return li.sku === GIFT_SKU || (GIFT_VID > 0 && li.variant_id === GIFT_VID); }
  function isCase(li) {
    if (isGift(li)) { return false; }
    var p = li.properties || {};
    if (p._bundleEpoch) { return false; }
    var t = String(li.title || '').toLowerCase();
    if (/nano-?glass|pro-shield/.test(t)) { return false; }
    return /pro-shock|full-shock|real-material/.test(t);
  }
  function ring(li) { var p = li.properties || {}; return p[RING] ? String(p[RING]) : ''; }
  /* the key the Function accepts: the case's SKU, or its variant id when it has none (the product page's caseSku) */
  function caseKey(c) { return c.sku ? String(c.sku) : String(c.variant_id); }
  function paired(g, c) {
    var k = String((g.properties || {}).caseSku || '');
    return !!k && (k === String(c.sku || '') || k === String(c.variant_id)) && ring(g) === ring(c);
  }

  /* what the cart needs: null when it is already right */
  function plan(cart) {
    var items = (cart && cart.items) || [];
    var gifts = items.filter(isGift);
    if (!gifts.length) { return null; }
    var cases = items.filter(isCase);
    var updates = {};
    var n = 0;
    if (!cases.length) {
      gifts.forEach(function (g) { updates[g.key] = 0; n++; });
      return { updates: updates, repair: null };
    }
    var keep = null;
    gifts.forEach(function (g) { if (!keep && cases.some(function (c) { return paired(g, c); })) { keep = g; } });
    if (!keep) { keep = gifts[0]; }
    gifts.forEach(function (g) { if (g !== keep) { updates[g.key] = 0; n++; } });
    var repair = null;
    if (!cases.some(function (c) { return paired(keep, c); })) {
      var c = cases[0];
      var props = {};
      var old = keep.properties || {};
      Object.keys(old).forEach(function (k) { if (k !== 'caseSku' && k !== PAIR_LABEL && k !== RING) { props[k] = old[k]; } });
      props.caseSku = caseKey(c);
      props[PAIR_LABEL] = String(c.product_title || '') + (c.variant_title ? ' – ' + c.variant_title : '');
      if (ring(c)) { props[RING] = ring(c); }
      repair = { id: keep.key, quantity: 1, properties: props };
    } else if (keep.quantity !== 1) {
      updates[keep.key] = 1; n++;
    }
    if (!n && !repair) { return null; }
    return { updates: n ? updates : null, repair: repair };
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error(url + ' returned ' + r.status); }
      return r.json();
    });
  }

  var selfDispatch = false;
  function repaint(cart) {
    if (W.mfCart) { W.mfCart.invalidate(); }
    selfDispatch = true;
    try {
      D.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    } catch (e) {}
    selfDispatch = false;
  }

  var busy = false;
  /* a check that came in while a repair was in flight: run once more when it settles (verify 2026-10-05 - a second
     cart change during a slow repair used to be dropped, leaving the gift unpaired and charged until the next cart
     event or page load) */
  var again = false;
  var writes = [];
  function budget() {
    var now = Date.now();
    writes = writes.filter(function (t) { return now - t < 30000; });
    if (writes.length >= 4) { return false; }
    writes.push(now);
    return true;
  }

  /* PL 2026-10-13 (popup A/B/C port): the fresh read and the corrective writes run as ONE job in window.mfCartLock
     (snippets/mf-cart-lock.liquid, defined inline in the head), so a repair never lands in the middle of the popup
     test's prize write (discount + mf_pgt), the price-tier / mf_pga attribute writes or a coupon-chip removal, and it
     decides on the cart the previous writer left. Its /cart/update.js carries only line updates and its
     /cart/change.js only the gift line's properties, so the discount list and the cart attributes are untouched. */
  function locked(job) { return W.mfCartLock ? W.mfCartLock(job) : Promise.resolve().then(job); }
  function fix() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    locked(function () { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (fresh) {
        var p = plan(fresh);
        if (!p || !budget()) { return; }
        /* the last request carries the drawer's HTML, so the repaint needs no second round trip */
        var chain = Promise.resolve(null);
        if (p.updates) {
          chain = chain.then(function () {
            return post('/cart/update.js', p.repair ? { updates: p.updates } : { updates: p.updates, sections: 'mini-cart' });
          });
        }
        if (p.repair) {
          chain = chain.then(function () {
            return post('/cart/change.js', { id: p.repair.id, quantity: 1, properties: p.repair.properties, sections: 'mini-cart' });
          });
        }
        return chain.then(function (cart) { if (cart) { repaint(cart); } });
      }); })
      .catch(function (e) { try { console.error('[mf] gift pairing', e); } catch (e2) {} })
      .then(function () {
        busy = false;
        /* the rerun decides on a fresh /cart.js again, so a check this repair already answered costs one GET and
           no write */
        if (again) { again = false; fix(); }
      });
  }

  var timer = 0;
  function check(cart) {
    if (cart && Array.isArray(cart.items)) {
      if (plan(cart)) { fix(); }
      return;
    }
    var load = W.mfCart ? W.mfCart.get() : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    load.then(function (c) { if (plan(c)) { fix(); } }).catch(function () {});
  }
  function onCart(ev) {
    if (selfDispatch) { return; }
    var cart = ev && ev.detail && ev.detail.cart;
    clearTimeout(timer);
    /* after theme.js / product-rhode have finished their own chain (their cart:updated follows the paint), and after
       the drawer's delayed paint of that same change: theme.js LineItemQuantity hands its update.js HTML over with a
       600 / 750 ms replacementDelay and repaint() above has none, so the 900 ms keeps the repaired cart the LAST paint.
       Below 750 ms the theme's older HTML lands on top - after a '-' on the last case the drawer kept showing the
       charged gift while the server cart was empty (the RO reconciler, verify 2026-10-05). The rerun in fix() only
       follows a check, so it keeps that order. */
    timer = setTimeout(function () { check(cart && Array.isArray(cart.items) ? cart : null); }, 900);
  }

  function boot() {
    D.documentElement.addEventListener('cart:updated', onCart, false);
    D.documentElement.addEventListener('cart:refresh', onCart, false);
    /* an empty cart (the server-seeded count) has nothing to pair - no request at load */
    var n = W.mfCart ? W.mfCart.count() : 1;
    if (n > 0) { setTimeout(function () { check(null); }, 1500); }
  }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot, false); }
  else { boot(); }
})();
